import { RoleName } from 'constants/constants';
import useCurrentUser from 'hooks/useCurrentUser';

/**
 * Check if current user has a specific role.
 */
export function useHasRole(roleName: string): boolean {
  const user = useCurrentUser();
  return user.roles?.some((r) => r.name === roleName) ?? false;
}

/**
 * Check if current user is a System Administrator.
 */
export function useIsSystemAdmin(): boolean {
  return useHasRole(RoleName.SYSTEM_ADMIN);
}

/**
 * Check if current user is a Super Admin (RoleName.ADMIN).
 */
export function useIsAdmin(): boolean {
  return useHasRole(RoleName.ADMIN);
}
